export default "__VITE_ASSET__Db_g9G5c__"